module.exports = "https://static.im-cdn.com/mjc/storefront/Coral/static/media/shareFB.47c245c1.svg";